var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_kng_mark_lbl_key_mark" /** 关键点标记 */),
        size: "960px",
        "custom-class": "yxtbiz-kng-point",
        visible: _vm.visible,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-flex yxtbiz-kng-point__main" }, [
        _c(
          "div",
          { staticClass: "yxtbiz-flex-1" },
          [
            _c(
              "yxt-scrollbar",
              { attrs: { "fit-height": true } },
              [
                _c(
                  "div",
                  { staticClass: "pr24 pt24 pl24" },
                  [
                    _vm.playerOptions.fileId
                      ? _c(
                          "yxtbiz-video",
                          _vm._b(
                            {
                              ref: "player",
                              staticClass: "yxtbizf-br-4",
                              attrs: {
                                marks: _vm.list,
                                width: "100%",
                                height: "243px",
                              },
                              on: {
                                markJump: _vm.markJump,
                                onPlay: function ($event) {
                                  _vm.playing = true
                                },
                                onTime: _vm.updateViewLoc,
                              },
                            },
                            "yxtbiz-video",
                            _vm.playerOptions,
                            false
                          )
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "yxt-tabs",
                  {
                    staticClass: "mt12",
                    model: {
                      value: _vm.activeName,
                      callback: function ($$v) {
                        _vm.activeName = $$v
                      },
                      expression: "activeName",
                    },
                  },
                  [
                    _c(
                      "yxt-tab-pane",
                      {
                        staticClass: "ph24 pb24",
                        attrs: {
                          label: _vm.$t(
                            "pc_biz_lbl_manualmark" /** 手动标记 */
                          ),
                          name: "1",
                        },
                      },
                      [
                        _c("form-point-form", {
                          attrs: {
                            form: _vm.form,
                            "insert-disabled": _vm.insertDisabled,
                          },
                        }),
                        _c(
                          "yxt-button",
                          {
                            staticClass: "mt24",
                            attrs: {
                              type: "second",
                              disabled: !_vm.form.time || !_vm.form.desc,
                            },
                            on: { click: _vm.add },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_btn_add" /** 添加 */)))]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "yxt-tab-pane",
                      {
                        staticClass: "ph24 pb24",
                        attrs: {
                          label: _vm.$t(
                            "pc_kng_mark_btn_batch_mark" /** 批量标记 */
                          ),
                          name: "2",
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "yxtbiz-flex-center" },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.$t(
                                    "pc_kng_mark_lbl_tag_content" /** 标记内容 */
                                  )
                                ) +
                                "\n              "
                            ),
                            _c(
                              "yxt-tooltip",
                              {
                                attrs: {
                                  "max-width": "400",
                                  effect: "dark",
                                  placement: "bottom",
                                  content: _vm.$t(
                                    "pc_kng_upload_lbl_browse_allowtip" /*设置后即使无目录浏览权限也支持浏览*/
                                  ),
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    attrs: { slot: "content" },
                                    slot: "content",
                                  },
                                  [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_mark_lbl_tag_content_desc1" /*1. 关键帧时间最大不能超出课件时长。*/
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_mark_lbl_tag_content_desc2" /*2. 关键帧至少从00:01开始标记。*/
                                          )
                                        )
                                    ),
                                    _c("br"),
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "pc_kng_mark_lbl_tag_content_desc3" /*3. 关键帧描述50字以内。*/
                                          )
                                        ) +
                                        "\n                "
                                    ),
                                  ]
                                ),
                                _c("yxt-svg", {
                                  staticClass: "hand v-mid color-gray-6 ml4",
                                  attrs: {
                                    width: "16px",
                                    height: "16px",
                                    "icon-class": "icons/question-cirlce-o",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("yxt-input", {
                          staticClass: "mt8",
                          attrs: {
                            type: "textarea",
                            rows: 10,
                            placeholder: _vm
                              .$t("pc_kng_mark_msg_tag_example")
                              .replace(/\\r\\n/g, "\r\n"),
                            "show-word-limit": "",
                          },
                          model: {
                            value: _vm.batchText,
                            callback: function ($$v) {
                              _vm.batchText = $$v
                            },
                            expression: "batchText",
                          },
                        }),
                        _c(
                          "yxt-button",
                          {
                            staticClass: "mt24",
                            attrs: { type: "second", disabled: !_vm.batchText },
                            on: { click: _vm.addBatch },
                          },
                          [_vm._v(_vm._s(_vm.$t("pc_biz_btn_add" /** 添加 */)))]
                        ),
                      ],
                      1
                    ),
                    _vm.showAiPoints
                      ? _c(
                          "yxt-tab-pane",
                          {
                            staticClass: "ph24 pb8",
                            attrs: {
                              label: _vm.$t(
                                "pc_biz_btn_autoadd" /** 自动标记 */
                              ),
                              name: "3",
                            },
                          },
                          [
                            _vm.autoMarkList.length === 0
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "color-gray-7 text-center mt32",
                                  },
                                  [
                                    _c("yxt-empty", {
                                      attrs: {
                                        "empty-text": _vm.$t(
                                          "pc_biz_lbl_nopoints" /** 暂无关键点 */
                                        ),
                                      },
                                    }),
                                    _c("div", {
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("pc_biz_lbl_automarktip")
                                        ),
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : [
                                  _c(
                                    "div",
                                    {
                                      ref: "title",
                                      staticClass: "color-gray-7",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "pc_biz_lbl_selectautomark" /** 请选择以下关键点标记（标记是由AI字幕中自动提炼的主题） */
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "yxt-table",
                                    {
                                      ref: "table",
                                      staticClass: "mt16",
                                      attrs: {
                                        "max-height": _vm.maxHeight,
                                        data: _vm.autoMarkList,
                                        "row-key": "id",
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange,
                                      },
                                    },
                                    [
                                      _c("yxt-table-column", {
                                        attrs: {
                                          type: "selection",
                                          "reserve-selection": true,
                                          width: "32",
                                        },
                                      }),
                                      _c("yxt-table-column", {
                                        attrs: {
                                          prop: "markTime",
                                          label: _vm.$t(
                                            "pc_kng_mark_btn_point_time" /** 时间点 */
                                          ),
                                          width: "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.getDurationFormat(
                                                          scope.row.markTime
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          965008695
                                        ),
                                      }),
                                      _c("yxt-table-column", {
                                        attrs: {
                                          prop: "markDesc",
                                          label: _vm.$t(
                                            "pc_biz_udp_lbl_description" /** 描述 */
                                          ),
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "yxt-button",
                                    {
                                      staticClass: "mt16",
                                      attrs: {
                                        type: "second",
                                        disabled: !_vm.autoSelected.length,
                                      },
                                      on: { click: _vm.addAuto },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("pc_biz_btn_add" /** 添加 */)
                                        )
                                      ),
                                    ]
                                  ),
                                ],
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c("div", { staticClass: "yxtbiz-flex-1" }, [
          _c("div", { staticClass: "mt24 ph24" }, [
            _vm._v(_vm._s(_vm.$t("pc_biz_lbl_marknumber", [_vm.list.length]))),
          ]),
          _c(
            "div",
            { staticClass: "yxtbiz-kng-point__list-main" },
            [
              _c("yxt-scrollbar", { attrs: { "fit-height": true } }, [
                _c(
                  "div",
                  { staticClass: "ph24" },
                  _vm._l(_vm.list, function (item, index) {
                    return _c("form-point-cell", {
                      key: index,
                      attrs: {
                        "cell-data": item,
                        "is-edit": item === _vm.current,
                      },
                      on: {
                        change: _vm.change,
                        save: _vm.save,
                        delete: function ($event) {
                          return _vm.del(index)
                        },
                      },
                    })
                  }),
                  1
                ),
              ]),
            ],
            1
          ),
        ]),
      ]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_comment_cancel" /** 取消 */)))]
          ),
          _c(
            "yxt-button",
            { attrs: { type: "primary" }, on: { click: _vm.confirm } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure" /** 确定 */)))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }